<div class="wrapper">
  <app-text-input
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="title"
    label="title"
    />
  <app-text-area
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="description"
    label="Description"
    />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableSearch]="true"
    [error]="errorMessages['projectScope']"
    [options]="projectScopeOptions"
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="projectScope"
    label="Project Scope"
    placeholder="Search"
    />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableDetailedOptionView]="true"
    [enableMultiple]="true"
    [enableSearch]="true"
    [error]="errorMessages['bid']"
    [options]="bidItemOptions"
    [parentFormGroup]="form"
    [selectionString]="form.controls['bidItem']?.value?.length > 1 ? 'Bid Items' : 'Bid Item' "
    [showCount]="true"
    class="mb-[20px]"
    controlName="bidItem"
    label="Bid Item"
    placeholder="Search"
    />
  <div class="selected-bid-item-list flex flex-col justify-center mb-[40px]">
    @if (selectedBidItemIds.length) {
      @for (bidItems of selectedBidItemIds; track bidItems) {
        <div
          class="bid-item-id-details-container mb-[10px]">
          <div class="bid-item-id-details text-type-11">
            <div
              class="each-item flex justify-start items-center gap-[16px]"
              >
              <div class="left flex justify-start items-center">
                <div class="icon-wrapper">
                  <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                </div>
              </div>
              <div class="right flex flex-col justify-center items-start">
                <div class="bid-item-heading text-type-6">Bid item {{ bidItems?.item }}</div>
                <div class="h-[1px]">&nbsp;</div>
                <div class="description text-type-14">{{ bidItems?.description }}</div>
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="activity-id-name-container">
        <div
          class="activity-id-name text-type-11">
          No bid items selected
        </div>
      </div>
    }
  </div>
  @if (!isContractor) {
  <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
    <div class="label text-type-13 ">
      Internal:
    </div>
    <mat-slide-toggle
      (change)="onToggle($event)"
      [checked]="form?.controls?.internal?.value"
      [disableRipple]="false"
      [disabled]="isMarkerClick || !editable"
      class="slide-toggle-btn"
      color="primary"
      >
    </mat-slide-toggle>
  </div>
  }
  <app-button-select
    (checkForErrors)="checkForErrors($event)"
    [error]="errorMessages['type']"
    [isEditable]="editable && !isMarkerClick"
    [options]="categoryOptions"
    [parentFormGroup]="form"
    class="mb-[40px]"
    controlName="type"
    label="category"
    />
  @if (mediaFiles?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [isEditable]="editable && !isMarkerClick"
      [pictures]="mediaFiles"
      [selectedLineItem]="data"
      class="pictures-section mb-[40px]"
      />
  }
  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [isEditable]="editable && !isMarkerClick"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [locationText]="form?.controls?.location?.value"
      [stationRange]="form?.controls?.station_range?.value"
      [form]="form"
      [recordLabel]="'issue'"
      [markupKind]="markupKind"
      class="location-section mb-[40px]"
      />
  }
  @if (data?.comment) {
    <app-text-area
      [parentFormGroup]="form"
      class="mb-[40px]"
      controlName="comment"
      label="comments"
      />
  }
</div>
